// extracted by mini-css-extract-plugin
export default {"modalOverlay":"OyDXWfB3","modal":"b1FyWLsM","hasTitle":"kWxwIvkN","modalBody":"ajO72RsN"};